import { t } from "@/i18n-js/instance";
import { planSettingsPath } from "@/react/helpers/urlHelpers";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const CancellationBanner = () => {
  const handleRenewClick = () => {
    window.location.href = planSettingsPath();
  };

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Typography.BodySm
          weight="font-normal"
          size="text-darkest"
          color="text-white"
        >
          {t("trial_banner.to_access_community")}
        </Typography.BodySm>
        <Button
          className="text-base font-semibold"
          variant="secondary"
          onClick={handleRenewClick}
        >
          {t("trial_banner.renew_subscription")}
        </Button>
      </div>
    </div>
  );
};
